<template>
	<div class="col" gutter="20">
		<div class="row" align-y="top" gutter="10">
			<div style="flex:1">
				<slot />
			</div>
			<el-button v-if="canEdit" type="text" icon="el-icon-edit" @click="$emit('edit')">點選修改</el-button>
		</div>
		<div class="row" align-x="right" gutter="10">
			<slot name="button" />
			<el-button type="danger" @click="$emit('next')">下一步</el-button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
	props: {
		"edit-button-top": Boolean,
		userEdit: {
			default: true
		}
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		...mapState("user", ["userInfo"]),
		canEdit() {
			if (this.userInfo.role == "admin") {
				return true;
			}
			let storyStatus = this.editStoryData.apply_status;
			let canEditStatus = [1, 3];
			if (this.userEdit && _.indexOf(canEditStatus, storyStatus) != -1) {
				return true;
			}
			return false;
		}
	},
	created() { }
};
</script>
